var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9883 9.20475H19.2499V9.16671H10.9999V12.8334H16.1805C15.4247 14.9678 13.3938 16.5 10.9999 16.5C7.96254 16.5 5.49992 14.0374 5.49992 11C5.49992 7.96267 7.96254 5.50004 10.9999 5.50004C12.402 5.50004 13.6775 6.02896 14.6487 6.89292L17.2415 4.30012C15.6043 2.77433 13.4144 1.83337 10.9999 1.83337C5.93763 1.83337 1.83325 5.93775 1.83325 11C1.83325 16.0623 5.93763 20.1667 10.9999 20.1667C16.0622 20.1667 20.1666 16.0623 20.1666 11C20.1666 10.3854 20.1033 9.78546 19.9883 9.20475Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89014 6.73342L5.90184 8.94212C6.71676 6.92454 8.69034 5.50004 10.9999 5.50004C12.4019 5.50004 13.6775 6.02896 14.6487 6.89292L17.2415 4.30012C15.6043 2.77433 13.4144 1.83337 10.9999 1.83337C7.47897 1.83337 4.42555 3.82117 2.89014 6.73342Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.1666C13.3677 20.1666 15.5191 19.2605 17.1458 17.7869L14.3087 15.3862C13.3574 16.1096 12.1951 16.5009 11 16.4999C8.61573 16.4999 6.59127 14.9797 5.82861 12.858L2.83936 15.1612C4.35644 18.1298 7.43736 20.1666 11 20.1666Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9884 9.20467H19.25V9.16663H11V12.8333H16.1805C15.819 13.8491 15.1678 14.7368 14.3073 15.3867L14.3087 15.3858L17.1458 17.7865C16.945 17.9689 20.1667 15.5833 20.1667 11C20.1667 10.3853 20.1034 9.78538 19.9884 9.20467Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.3fab1a4a686c6958361be185ec005bd7.svg";
export { ForwardRef as ReactComponent };